import { faPencil, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Billable, ICreditCardSource, TSource } from '@feathr/blackbox';
import { isBankAccountSource, isCreditCardSource } from '@feathr/blackbox';
import { Alert, AlertType, Button, Modal } from '@feathr/components';
import { useToggle } from '@feathr/hooks';

import BankAccount from './BankAccount';
import CreditCard from './CreditCard';

import * as styles from './BillingSource.css';

interface IProps {
  className?: string;
  billable: Billable;
  onDelete?: () => void;
  onUpdate?: () => void;
  source: TSource;
}

function BillingSource({ billable, className, onDelete, onUpdate, source }: IProps) {
  const [isDeleteModalOpen, toggleIsDeleteModalOpen] = useToggle(false);
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.root, className)}>
      {isBankAccountSource(source) && <BankAccount billable={billable} />}
      {isCreditCardSource(source) && <CreditCard source={source as ICreditCardSource} />}
      {onUpdate && (
        <Button onClick={onUpdate} prefix={<FontAwesomeIcon icon={faPencil} />}>
          {t('Update')}
        </Button>
      )}
      {onDelete && (
        <Button onClick={toggleIsDeleteModalOpen} prefix={<FontAwesomeIcon icon={faTrashAlt} />}>
          {t('Delete')}
        </Button>
      )}
      {isDeleteModalOpen && (
        <Modal
          confirmButtonText={t('Yes, Delete')}
          controlled={true}
          onClose={toggleIsDeleteModalOpen}
          onConfirm={onDelete}
          t={t}
        >
          <Alert type={AlertType.danger}>
            {t('Are you sure you want to delete this payment method?')}
          </Alert>
        </Modal>
      )}
    </div>
  );
}

export default BillingSource;
